import { createContext } from 'react'
import { createSelectorHook } from 'react-redux'
import { compose, createStore, applyMiddleware, combineReducers } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import wapprunnerPoolReducer from '../wapprunner-pool/wapprunnerPool.reducer'

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'wapprunner',
      })
    : compose
/* eslint-enable */

const epicMiddleware = createEpicMiddleware()

const store = createStore(
  combineReducers({
    pool: wapprunnerPoolReducer,
  }),
  composeEnhancers(applyMiddleware(epicMiddleware)),
)

export const { getState, dispatch } = store
export default store

export const ReduxContext = createContext()
export const useSelector = createSelectorHook(ReduxContext)
